/* eslint-disable max-classes-per-file */

export class InboxMessageCardsNotLoadedError extends Error {
  constructor() {
    super('Inbox message cards have not been loaded yet.')
    this.name = 'InboxMessageCardsNotLoadedError'
  }
}

export class InboxMessageCardNotFound extends Error {
  cardId?: string

  constructor({ cardId }: { cardId: string }) {
    super('The requested inbox message card was not found.')
    this.name = 'InboxMessageCardNotFound'
    this.cardId = cardId
  }
}
